document.addEventListener('DOMContentLoaded', function () {
  function addSavingsBadges() {
    document.querySelectorAll('.product-card-wrapper').forEach(function (card) {
      if (card.querySelector('.devlistic-savings-badge')) return;

      const salePriceEl = card.querySelector('.price-item--sale.price-item--last');
      const comparePriceEl = card.querySelector('s.price-item--regular');
      if (!salePriceEl || !comparePriceEl) return;

      const salePrice = parseFloat(salePriceEl.textContent.replace(/[^\d.]/g, ''));
      const comparePrice = parseFloat(comparePriceEl.textContent.replace(/[^\d.]/g, ''));

      if (comparePrice > salePrice) {
        const saving = Math.round(comparePrice - salePrice);
        const badge = document.createElement('div');
        badge.className = 'devlistic-savings-badge';
        badge.textContent = '🎉 You save ₹' + saving;
        const priceDiv = card.querySelector('.price');
        if (priceDiv) priceDiv.insertAdjacentElement('afterend', badge);
      }
    });
  }

  addSavingsBadges();

  // Also run after any dynamic content loads (infinite scroll, filters etc.)
  const observer = new MutationObserver(addSavingsBadges);
  observer.observe(document.body, { childList: true, subtree: true });
});